import type { MapProviderType } from 'src/types/map-provider';

import { Box } from '@mui/material';

import { ERROR_STATE_BOX_STYLES } from '../styles/universal-location-map.styles';

export interface MapErrorStateProps {
  height: string | number;
  errorMessage: string;
  providerType?: MapProviderType;
}

export function MapErrorState({ height, errorMessage, providerType }: MapErrorStateProps) {
  const showBaiduHelp = providerType === 'baidu';
  const boxStyles = { ...ERROR_STATE_BOX_STYLES, height };

  return (
    <Box sx={boxStyles}>
      <Box sx={{ fontSize: '48px', mb: 2 }}>❌</Box>
      <Box sx={{ fontWeight: 'bold', mb: 1, fontSize: '18px', color: 'error.dark' }}>
        Map Loading Failed
      </Box>
      <Box sx={{ fontSize: '14px', color: 'error.dark', mb: 2 }}>{errorMessage}</Box>
      {showBaiduHelp && (
        <Box sx={{ fontSize: '12px', color: 'text.secondary' }}>
          Please check your Baidu Maps API key and restart the dev server.
        </Box>
      )}
    </Box>
  );
}
